import { authClient } from "@corpuscomplete/web/auth/client";
import { Button } from "@corpuscomplete/web-ui/components/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@corpuscomplete/web-ui/components/card";
import { Text } from "@corpuscomplete/web-ui/components/text";
import { Clock, Mail } from "lucide-react";

export function WaitlistPage() {
  const handleSignOut = async () => {
    await authClient.signOut();
    window.location.href = "/login";
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 p-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="space-y-1 text-center">
          <div className="mb-4 flex justify-center">
            <div className="rounded-full bg-primary/10 p-4">
              <Clock className="h-8 w-8 text-primary" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold">You&apos;re on the Waitlist!</CardTitle>
          <CardDescription className="text-base">
            Thanks for your interest in Corpus Complete
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-4 text-center">
            <Text className="text-muted-foreground">
              We&apos;re currently in limited beta and adding new users gradually. You&apos;ll
              receive an email when your account is activated.
            </Text>

            <div className="flex items-center justify-center gap-2 text-muted-foreground">
              <Mail className="h-4 w-4" />
              <Text className="text-sm">We&apos;ll notify you when you&apos;re in!</Text>
            </div>
          </div>

          <div className="border-t pt-4">
            <Button variant="outline" onClick={handleSignOut} className="w-full">
              Sign out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
